/***
 * @func: 基于axios 二次封装
 ***/
import AxiosInstance, { AxiosError, AxiosPromise, AxiosStatic, Method } from 'axios'
import qs from 'qs'
// 定义一个请求的参数类型声明
type requestFn = (url: string, params?: Object, data?: Object | null, config?: Object) => AxiosPromise

class Http {
  // 请求对象
  private readonly axios: AxiosStatic = AxiosInstance

  // 在constructor里面进行初始化设置
  constructor () {
    const { axios } = this
    // axios.defaults.headers = {
    // 'Content-Type': 'application/json;charset=UTF-8'
    // }
    axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'

    // 去执行 请求拦截器 和 响应拦截器
    this.useInterceptResponse()
    this.useInterceptRequest()
  }

  // 响应拦截器
  useInterceptResponse () {
    this.axios.interceptors.response.use(
      (res) => {
        // 处理逻辑
        if (res.status === 200) {
          return Promise.resolve(res.data)
        }
        // 非200
        return Promise.reject(res.data)
      },
      (error: AxiosError) => {
        return Promise.reject(error)
      }
    )
  }

  // 请求拦截器
  useInterceptRequest () {
    this.axios.interceptors.request.use(
      async (config: any) => {
        if (config.headers?.post['Content-Type']?.includes('x-www-form-urlencoded') && config.method === 'post') {
          config.data = qs.stringify(config.data)
        }
        return config
      },
      (error: AxiosError) => Promise.reject(error)
    )
  }

  /**
   *
   * @param type 请求的方式
   * @param url 请求的地址
   * @param options 请求的参数
   * @param config 请求配置
   */
  private fetchData (type: Method, url: string, options?: Object, config?: Object) {
    return this.axios({
      method: type,
      url,
      ...options,
      ...config
    })
  }

  /**
   *
   * @param url 请求地址
   * @param params 请求参数
   * @param data null
   * @param config 请求配置
   */
  public get: requestFn = (url, params, data = null, config = {}) => {
    // get 可以不传参数
    if (!params) return this.fetchData('get', url, {}, config)
    // 因为get请求，很有可能会被缓存，所以我们需要给它加一个随机参数，
    // 实现： 因为params 是已经存在的， 我们只需要给它扩展一个随机数的变量即可
    // const newParams = Object.assign(params, {
    // [`dmx${new Date().getTime()}`]: 1,
    // })

    return this.fetchData('get', url, { params: params }, config)
  }

  /**
   *
   * @param type post put patch delete
   * @param url 请求地址
   * @param params 请求参数url上的参数
   * @param data 请求参数
   * @param config 请求配置
   */
  private commonRequest (type: Method, url: string, params?: Object, data?: Object | null, config?: Object): AxiosPromise {
    // 合并一下参数
    let options: Object = {
      params,
      data
    }
    if (params && data === undefined) {
      options = {
        data: params
      }
    }
    if (data === null) {
      options = {
        params
      }
    }
    return this.fetchData(type, url, options, config)
  }

  /**
   *
   * @param url 请求地址
   * @param params 请求url上加的参数 例?action=123
   * @param data 请求体body的数据
   * @param config 请求配置
   */
  public post: requestFn = (url, params, data, config) => {
    return this.commonRequest('post', url, params, data, config)
  }

  /**
   *
   * @param url 请求地址
   * @param params 请求url上加的参数 例?action=123
   * @param data 请求体body的数据
   * @param config 请求配置
   */
  public put: requestFn = (url, params, data, config) => {
    return this.commonRequest('put', url, params, data, config)
  }

  /**
   *
   * @param url 请求地址
   * @param params 请求url上加的参数 例?action=123
   * @param data 请求体body的数据
   * @param config 请求配置
   */
  public patch: requestFn = (url, params, data, config) => {
    return this.commonRequest('patch', url, params, data, config)
  }

  /**
   *
   * @param url 请求地址
   * @param params 请求url上加的参数 例?action=123
   * @param data 请求体body的数据
   * @param config 请求配置
   */
  public delete: requestFn = (url, params, data, config) => {
    return this.commonRequest('delete', url, params, data, config)
  }
}

export default new Http()
